import { videoHotlineConstants } from "../actions/constants/videoHotlineConstants";

type VideoHotlineState = {
	items: any[];
};

const initialVideoHotline: VideoHotlineState = {
	items: [],
};

const videoHotlineData = (state = initialVideoHotline, action: any) => {
	switch (action.type) {
		case videoHotlineConstants.VideoHotlineGetByfilterRequest:
			return {
				...state,
				isLoading: true,
				isError: false,
				isSuccess: false,
			};
		case videoHotlineConstants.VideoHotlineGetByfilterSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isListSuccess: true,
				items: action.payload,
			};
		case videoHotlineConstants.VideoHotlineGetByfilterFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isListSuccess: true,
				status: action.payload,
			};

		case videoHotlineConstants.VideoHotlineDetailRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
			};
		case videoHotlineConstants.VideoHotlineDetailSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				videoHotlineInput: action.payload.messageDTO,
			};
		case videoHotlineConstants.VideoHotlineDetailFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				status: action.payload,
			};

		case videoHotlineConstants.GetMessageBoardIDRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
			};
		case videoHotlineConstants.GetMessageBoardIDSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				message: action.payload,
			};
		case videoHotlineConstants.GetMessageBoardIDFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				message: action.payload,
			};

		case videoHotlineConstants.VideoHotlineDeleteRequest:
			return {
				...state,
				isLoading: true,
				isError: false,
				isSuccess: false,
				isDeleteCompleted: false,
			};
		case videoHotlineConstants.VideoHotlineDeleteSuccess:
			return {
				...state,
				isLoading: false,
				isError: false,
				isSuccess: true,
				isDeleteCompleted: true,
				status: action.payload.status,
			};
		case videoHotlineConstants.VideoHotlineDeleteFailure:
			return {
				...state,
				isLoading: false,
				isError: true,
				isSuccess: false,
				isDeleteCompleted: true,
				status: action.payload,
			};

		default:
			return state;
	}
};

export default videoHotlineData;
